export default {
  containers: {
    location_info: 'Informacje o lokalizacji',
    attributes: 'Atrybuty',
    links: 'Linki',
  },
  labels: {
    title: 'Tytuł',
    phone_number: 'Numer telefonu',
    description: 'Opis',
    website: 'Strona internetowa',
    address: 'Adres',
    regular_hours: 'Regularne godziny otwarcia',
    page_urls: 'Adresy URL strony',
    monday: 'Poniedziałek',
    tuesday: 'Wtorek',
    wednesday: 'Środa',
    thursday: 'Czwartek',
    friday: 'Piątek',
    saturday: 'Sobota',
    sunday: 'Niedziela',
    twenty_four_hours: '24 godz.',
    open_24_hours: 'Otwarte 24 godziny',
    open_time: 'Godzina otwarcia',
    close_time: 'Godzina zamknięcia',
    url: 'URL',
    provider_type: 'Typ dostawcy',
    provider_types: {
      merchant: 'Sprzedawca',
      aggregator: 'Agregator',
    },
    place_action_type: 'Typ',
    is_preferred: 'Preferowany',
    place_action_types: {
      appointment: 'Rezerwacja wizyty',
      online_appointment: 'Rezerwacja wizyty online',
      dining_reservation: 'Link do rezerwacji',
      food_ordering: 'Zamawianie jedzenia z dostawą i/lub na wynos',
      food_delivery: 'Link do dostawy',
      food_takeout: 'Link na wynos',
      shop_online: 'Zakupy z dostawą i/lub odbiorem własnym',
    },
    no_links: 'Brak dostępnych linków dla tej firmy',
    url_menu: 'Link do menu',
    url_reservations: 'Link do rezerwacji',
  },
  placeholders: {
    title: 'Tytuł',
    phone_number: 'Numer telefonu',
    description: 'Opis',
    website: 'Strona internetowa',
    address: 'Adres',
    regular_hours: 'Regularne godziny otwarcia',
    page_urls: 'Adresy URL strony',
    address_line_1: 'Adres (wiersz 1)',
    postal_code: 'Kod pocztowy',
    locality: 'Miejscowość',
    region_code: 'Kod regionu',
    language_code: 'Kod języka',
    select_time: 'Wybierz godzinę',
    url: 'URL',
  },
  buttons: {
    submit: 'Zatwierdź',
    add: 'Dodaj',
    delete: 'Usuń',
    generate_description: 'Generuj opis (AI)',
  },
  validation: {
    required: 'To pole jest wymagane',
    invalid_url: 'Nieprawidłowy URL',
  },
  toasts: {
    success: 'Zmiany zostały zapisane!',
    description_generation_failed: 'Nie udało się wygenerować opisu. Spróbuj ponownie.',
  },
};
